import React, { Component } from 'react'
import { getPostMetatagsById } from '../services/PostApi';
import uuid from 'react-uuid';

class CommonTrendingVideoGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trendingVideosData: props.trendingVideosData
        }
    }

    getPostMetadatById = async (id) => {
        let response = await getPostMetatagsById(id);
        if(response?.message === "Success!") {
            let trendingVideosData = this.state.trendingVideosData;
            trendingVideosData.trendingVideoLink = response?.body?.videoUrl;
            this.setState({
                trendingVideosData
            })
        }
    }

    componentDidMount() {
        let trendingVideoLink = this.state.trendingVideosData?.trendingVideoLink;
        let urlValidPostWenat = trendingVideoLink.startsWith(process.env.REACT_APP_domainUrl + "/post");
        if (urlValidPostWenat) {
            let id = trendingVideoLink.substring(trendingVideoLink.lastIndexOf("/") + 1);
            this.getPostMetadatById(id);
        }
    }

    render() {
        const { trendingVideosData } = this.state;
        return (
            <div className='col-lg-6'>
                <div className={'lndSolVideoBlk' + (this.props.type === "SMALL" ? " smallVid" : "")}>
                    <a href={trendingVideosData?.trendingVideoLink} data-fancybox={`video${uuid()}`}>
                        <img src={trendingVideosData?.attachment?.attachmentUrl} alt="" />
                        <span className="btnYoutube"></span>
                    </a>
                </div>
            </div>
        )
    }
}

export default CommonTrendingVideoGrid;
